import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import {
  View,
  Image,
  BodyText,
  DividerLine,
  LinkFont,
  Box,
  Row,
  HoverButton,
  Pressable,
} from 'modules/styled';

import { exchangeLink, tokenEnabled } from 'modules/wallet/price.context';
import { goToUrl } from 'modules/navigation/navigation.actions';

function GetTokensModal() {
  return (
    <Box>
      {tokenEnabled() && (
        <Fragment>
          <BodyText sx={{ mt: 2, mb: 3 }}>
            You can buy and sell tokens on Uniswap Exchange
          </BodyText>
          <UniswapButton />
          <DividerLine sx={{ mt: 4 }} />
        </Fragment>
      )}
      <View sx={{ mt: 3, justifyContent: 'space-between' }}>
        <BodyText>Notice: All airdrop token rewards have been discontinued.</BodyText>
        <BodyText sx={{ mt: 1 }}>
          Users no longer receive tokens for referrals or email/Twitter confirmations.
        </BodyText>
      </View>
      {/*
      {(!user.confirmed || user?.role === 'admin') && (
        <View fdirection="column" justify={'space-between'}>
          <View fdirection="row" align="center" mt={4}>
            <BodyText inline={1}>
              Confirm your e-mail to get{' '}
              <CoinStat inline={1} size={2} amount={EMAIL_REWARD} /> *non-redeemable*{' '}
              {EMAIL_REWARD > 1 ? 'coins' : 'coin'}
            </BodyText>
          </View>
          <ULink
            to="#"
            onClick={sendConfirmation}
            onPress={sendConfirmation}
            external
            mr={['auto', 0]}
            mobile={mobile}
            fel
          >
            <Button w={[22, 'auto']} mt={3} mobile={mobile}>
              <LinkFont c={colors.white}>Confirm E-mail</LinkFont>
            </Button>
          </ULink>
          2}<SecondaryText sx={{ mt: 2 }}>
            *these coins cannot be cashed out, but can be used to earn curation rewards
          </SecondaryText>
          <SecondaryText sx={{ mt: 2 }}>
            *if you don't see a confirmation email in your inbox, please check your spam
            folder
          </SecondaryText>
          <Divider mt={4} />
        </View>
      )}

      {(!user.twitterId || user?.role === 'admin') && (
        <Box>
          <View fdirection={'row'} align="center" mt={4}>
            <BodyText inline={1}>
              Connect your Relevant account with your Twitter to get{' '}
              <CoinStat
                inline={1}
                size={2}
                amount={user.confirmed ? TWITTER_REWARD : TWITTER_REWARD + EMAIL_REWARD}
              />{' '}
              *non-redeemable* {TWITTER_REWARD > 1 ? 'coins' : 'coin'}
            </BodyText>
          </View>
          {twitterButton}
          <SecondaryText sx={{ mt: 2 }}>
            *these coins cannot be cashed out, but can be used to earn curation rewards
          </SecondaryText>
          <Divider mt={4} />
        </Box>
      )}
      {!user.redditId && redditButton && (
        <View>
          <View mt={4} fdirection="row" align="center">
            <BodyText c={colors.secondaryText} inline={1}>
              Connect your Relevant account with your Reddit account to earn{' '}
              <CoinStat inline={1} size={2} amount={REDDIT_REWARD} />{' '}
              {REDDIT_REWARD > 1 ? 'coins' : 'coin'}
            </BodyText>
          </View>
          {redditButton}
          <Divider mt={4} />
        </View>
       <View mt={4}>
        <ULink
          to="#"
          onClick={() => showModal('invite')}
          onPress={() => push('invites')}
          external
          mr="auto"
          mobile={mobile}
        >
          <LinkFont c={colors.blue}>Invite Friends</LinkFont>
        </ULink>
      </View>
      */}
    </Box>
  );
}

function UniswapButton() {
  const dispatch = useDispatch();
  const uniIcon = require('public/img/uniswap.png');
  const exchageUrl = exchangeLink();

  return (
    <Pressable to={exchageUrl} external sx={{ mr: ['auto', 0] }} target="_blank">
      <HoverButton
        sx={{
          width: ['auto', 22 * 8],
          bg: 'uniswap',
          m: 0,
        }}
        onPress={() => dispatch(goToUrl(exchageUrl))}
      >
        <Row sx={{ justifyContent: 'center', alignItems: 'center' }}>
          <Image
            resizeMode="contain"
            source={uniIcon}
            sx={{ width: 4, height: 4, mr: 1 }}
          />
          <LinkFont sx={{ color: 'white' }}>Uniswap Exchange</LinkFont>
        </Row>
      </HoverButton>
    </Pressable>
  );
}

export default GetTokensModal;
